/**
 * Endpoints of the merchant onboarding registration flow.
 *
 * Only the endpoints already migrated to the shared HTTP layer are listed here.
 * The remaining actions in this module still build their URL inline because
 * they are shared with screens outside onboarding and will move in a later
 * sprint.
 *
 * @readonly
 * @enum {string}
 */
const api = {
  VALIDATE_REKENING: '/index.php?r=api/v1/onboarding/rekening/validate-rekening',
  REGISTRASI_INDEX: '/index.php?r=api/v1/onboarding/registrasi/index',
  CHECK_EMAIL_PHONE: '/index.php?r=api/v1/onboarding/registrasi/em-phone',
  GET_OTP: '/index.php?r=api/v1/onboarding/registrasi/get-otp',
  USE_OTP: '/index.php?r=api/v1/onboarding/registrasi/use-otp',
  RESEND_OTP: '/index.php?r=api/v1/onboarding/registrasi/up-otp',
  CHANNEL_QR: '/index.php?r=api/v1/onboarding/registrasi/channel-qr',
  ACCOUNT_NUMBER: '/index.php?r=api/v1/onboarding/registrasi/account-number',
  REKENING_VALIDATE: '/index.php?r=api/v1/onboarding/rekening/validate',
};

export default api;
